module.exports = __webpack_public_path__ + "static/musee_olympique_stades2-6e118a5406021b57c58cf93d933bd494.png";